/**
 * Machine-readable reasons the API gives for refusing a request.
 *
 * The envelope's `error` string stays for callers that only log or show it
 * (an MCP client, curl); the screens translate the code instead, so the
 * language a refusal is shown in is the reader's rather than the server's.
 * Only refusals a person can act on carry a code — a malformed cursor or a
 * missing token is a client bug, and its English message is enough.
 */
export const API_ERROR_CODES = [
    "ADMIN_ONLY",
    "NOT_FOUND",
    "FORBIDDEN_VIEW",
    "FORBIDDEN_EDIT",
    "FORBIDDEN_UPLOAD",
    "CONTRACT_NOT_REVIEWABLE",
    "SELF_EDIT_LOCKOUT",
    "UPLOAD_GRANT_FOLDER_ONLY",
    "MOVE_INTO_DESCENDANT",
    "HIERARCHY_TOO_DEEP",
    "FOLDER_HAS_SUBFOLDERS",
    "FOLDER_HAS_CONTRACTS",
    "TEAM_HAS_SUBTEAMS",
    "TEAM_HAS_MEMBERS",
    "ADMIN_TEAM_UNDELETABLE",
    "ADMIN_TEAM_NO_SUBTEAMS",
    "FILE_TOO_LARGE",
    "UPLOAD_CANCEL_UPLOADER_ONLY",
    "UPLOAD_ALREADY_EXTRACTED",
    "UPLOAD_ALREADY_SENT",
];
/** What a `NOT_FOUND` or `FORBIDDEN_*` refusal is about. */
export const API_RESOURCES = ["contract", "folder", "team", "user"];
export function isApiErrorCode(value) {
    return (typeof value === "string" &&
        API_ERROR_CODES.includes(value));
}
export function isApiResource(value) {
    return (typeof value === "string" &&
        API_RESOURCES.includes(value));
}
//# sourceMappingURL=apiError.js.map